var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconAnalyticsGrey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12.34 12 25.55 26.25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M37.272,19.897h-5.701c-0.345,0-0.625,0.28-0.625,0.625v5.076H25.87c-0.345,0-0.625,0.28-0.625,0.625v5.075 H20.17c-0.345,0-0.625,0.28-0.625,0.625V37h-5.942v-7.043l8.105-6.224c0.369,0.271,0.821,0.436,1.313,0.436 c1.231,0,2.232-1.001,2.232-2.232c0-0.474-0.151-0.912-0.403-1.274l3.014-3.739c0.264,0.11,0.554,0.172,0.857,0.172 c1.013,0,1.86-0.682,2.132-1.607h1.437c0.272,0.926,1.119,1.607,2.132,1.607c1.231,0,2.232-1.001,2.232-2.232 s-1.001-2.232-2.232-2.232c-1.013,0-1.86,0.682-2.132,1.607h-1.437c-0.272-0.926-1.119-1.607-2.132-1.607 c-1.231,0-2.232,1.001-2.232,2.232c0,0.474,0.151,0.912,0.403,1.274l-3.014,3.739c-0.264-0.11-0.554-0.172-0.857-0.172 c-1.231,0-2.232,1.001-2.232,2.232c0,0.285,0.059,0.555,0.156,0.806l-7.342,5.638V12.625c0-0.345-0.28-0.625-0.625-0.625 s-0.625,0.28-0.625,0.625v25c0,0.345,0.28,0.625,0.625,0.625h7.192h5.7h5.701h5.701c0.345,0,0.625-0.28,0.625-0.625V20.522 C37.897,20.178,37.617,19.897,37.272,19.897z M34.422,13.881c0.542,0,0.982,0.44,0.982,0.982s-0.44,0.982-0.982,0.982 s-0.982-0.44-0.982-0.982S33.88,13.881,34.422,13.881z M28.721,13.881c0.542,0,0.982,0.44,0.982,0.982s-0.44,0.982-0.982,0.982 s-0.982-0.44-0.982-0.982S28.179,13.881,28.721,13.881z M23.021,20.954c0.542,0,0.982,0.44,0.982,0.982s-0.44,0.982-0.982,0.982 s-0.982-0.44-0.982-0.982S22.479,20.954,23.021,20.954z M20.795,32.549h4.45V37h-4.45V32.549z M26.495,31.924v-5.075h4.451V37 h-4.451V31.924z M32.196,37V26.224v-5.076h4.451V37H32.196z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 12.978,12.625 12.978,37.625 37.272,37.625  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.17,
    y: 31.924,
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 5.701,
    height: 5.701
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.87,
    y: 26.223,
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 5.701,
    height: 11.402
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.571,
    y: 20.523,
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 5.701,
    height: 17.102
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12.978,
    y1: 29.649,
    x2: 21.75,
    y2: 22.912
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 23.02,
    cy: 21.937,
    r: 1.607
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 28.721,
    cy: 14.864,
    r: 1.607
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 34.422,
    cy: 14.864,
    r: 1.607
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 24.024,
    y1: 20.691,
    x2: 27.717,
    y2: 16.109
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.328,
    y1: 14.864,
    x2: 32.814,
    y2: 14.864
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconAnalyticsGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-analytics-grey.afcc97ee.svg";
export { ForwardRef as ReactComponent };